webpackJsonp([17],{

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
/** Import frontoffice_app */

__webpack_require__(5);

var _cart = _interopRequireDefault(__webpack_require__(11));

var _ajax_handler = _interopRequireDefault(__webpack_require__(6));

var _const = _interopRequireDefault(__webpack_require__(39));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @class CheckoutHandler
 */
var CheckoutHandler =
/*#__PURE__*/
function () {
  /**
   * @constructor
   */
  function CheckoutHandler() {
    _classCallCheck(this, CheckoutHandler);

    this._loadCartData();

    this._listenUserId();

    this._listenSubmit();
  }
  /**
   * @private
   */


  _createClass(CheckoutHandler, [{
    key: "_listenSubmit",
    value: function _listenSubmit() {
      $('[name="order_form"]').submit(function () {
        $("#order_form_submit").attr("disabled", true);
        return true;
      });
    }
    /**
     * @private
     */

  }, {
    key: "_listenUserId",
    value: function _listenUserId() {
      var userId = $('#user-placeholder').data('user');

      if (userId) {
        var link = 'user/' + userId + '/data';

        _ajax_handler.default.get(link).then(function (response) {
          if (response.user) {
            $('#order_form_userId').val(response.user.id);
            $('#order_form_customerName').val(response.user.firstName);
            $('#order_form_customerLastname').val(response.user.lastName);
            $('#order_form_address').val(response.user.address);
            $('#order_form_city').val(response.user.city);
            $('#order_form_zip').val(response.user.zip);
            $('#order_form_country').val(response.user.country);
            $('#order_form_mail').val(response.user.mail);
            $('#order_form_phone').val(response.user.phone);

            if (response.user.company) {
              $('#order_form_company').val(response.user.company);
            }
          }
        });
      } else {
        if (!$('#order_form_country').val()) {
          $('#order_form_country').val('Srbija');
        }
      }
    }
    /**
     * @private
     */

  }, {
    key: "_loadCartData",
    value: function _loadCartData() {
      var cartHtml = '',
          cart = _cart.default.getCartItems(),
          cartTotals = _cart.default.getDeliveryTotal();

      $.each(cart, function (k, v) {
        var displayPrice = parseInt(v.price);

        if (_const.default.HIDDEN_DELIVERY === 'true') {
          displayPrice = displayPrice + parseInt(v.delivery_price);
        }

        cartHtml += '<div class="shipping-left">' + v.name + ' x ' + v.quantity + '<span class="price">' + displayPrice * v.quantity + ' rsd</span>' + '<input type="hidden" id="order_form_orderItems_' + k + '_productSlug" name="order_form[orderItems][' + k + '][productSlug]" value="' + v.slug + '" />' + '<input type="hidden" id="order_form_orderItems_' + k + '_unitPrice" name="order_form[orderItems][' + k + '][unitPrice]" value="' + v.price + '" />' + '<input type="hidden" id="order_form_orderItems_' + k + '_quantity" name="order_form[orderItems][' + k + '][quantity]" value="' + v.quantity + '" />' + '<input type="hidden" id="order_form_orderItems_' + k + '_deliveryPerItem" name="order_form[orderItems][' + k + '][deliveryPerItem]" value="' + v.delivery_price + '" />' + '<input type="hidden" id="order_form_orderItems_' + k + '_itemTotal" name="order_form[orderItems][' + k + '][itemTotal]" value="' + v.price * v.quantity + '" />' + '<input type="hidden" id="order_form_orderItems_' + k + '_deliveryTotal" name="order_form[orderItems][' + k + '][deliveryTotal]" value="' + v.delivery_price * v.quantity + '" />' + '</div>';
      });
      $('#cart-order-items').empty().html(cartHtml);
      $('#order_form_totalChart').val(cartTotals.totalItems);
      $('#order_form_deliveryPrice').val(cartTotals.delivery);
      $('#order_form_total').val(cartTotals.total);
      var displayTotal = parseInt(cartTotals.totalItems);

      if (_const.default.HIDDEN_DELIVERY === 'true') {
        displayTotal = displayTotal + parseInt(cartTotals.delivery);
      } else {
        $('#delivery-price').empty().html(cartTotals.delivery + ' rsd');
        $('#total').empty().html(cartTotals.total + ' rsd');
      }

      $('#total-chart').empty().html(displayTotal + ' rsd');
    }
  }]);

  return CheckoutHandler;
}();
/** Start CheckoutHandler */


$(document).ready(function () {
  new CheckoutHandler();
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ })

},[276]);


// WEBPACK FOOTER //
// frontoffice_checkout.js